module.exports = {
	"ha": "viha",
	"id": 5.3,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Island Health by Age Category, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "62%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "62%",
				"height": "38%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 88.13559322033898,
						"dataLabels": {
							"enabled": true,
							"format": "52",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.66101694915254,
						"dataLabels": {
							"enabled": true,
							"format": "47",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.57627118644068,
						"dataLabels": {
							"enabled": true,
							"format": "44",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.016949152542374,
						"dataLabels": {
							"enabled": true,
							"format": "36",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 45.76271186440678,
						"dataLabels": {
							"enabled": true,
							"format": "27",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "116",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.17241379310344,
						"dataLabels": {
							"enabled": true,
							"format": "93",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.72413793103449,
						"dataLabels": {
							"enabled": true,
							"format": "89",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 66.37931034482759,
						"dataLabels": {
							"enabled": true,
							"format": "77",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 37.93103448275862,
						"dataLabels": {
							"enabled": true,
							"format": "44",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "188",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 91.48936170212765,
						"dataLabels": {
							"enabled": true,
							"format": "172",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.2340425531915,
						"dataLabels": {
							"enabled": true,
							"format": "164",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.31914893617021,
						"dataLabels": {
							"enabled": true,
							"format": "151",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 51.59574468085106,
						"dataLabels": {
							"enabled": true,
							"format": "97",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 99.609375,
						"dataLabels": {
							"enabled": true,
							"format": "765",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.54166666666666,
						"dataLabels": {
							"enabled": true,
							"format": "680",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 85.546875,
						"dataLabels": {
							"enabled": true,
							"format": "657",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.42708333333334,
						"dataLabels": {
							"enabled": true,
							"format": "610",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.682291666666664,
						"dataLabels": {
							"enabled": true,
							"format": "443",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -11.864406779661019,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.615384615384615,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.382978723404253,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -18.181818181818176,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -19.82758620689655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.3010752688172005,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.48314606741573,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -42.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.510638297872342,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.651162790697672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.926829268292678,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -35.76158940397352,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -0.390625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.3823529411764697,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.153729071537295,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -27.377049180327873,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=59"
			},
			{
				"x": 9,
				"text": "30–39<br>n=116"
			},
			{
				"x": 15,
				"text": "40–49<br>n=188"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=768"
			}
		],
		"dataTable": {
			"< 30": [
				59,
				52,
				47,
				44,
				36,
				27
			],
			"30–39": [
				116,
				116,
				93,
				89,
				77,
				44
			],
			"40–49": [
				188,
				188,
				172,
				164,
				151,
				97
			],
			"≥ 50": [
				768,
				765,
				680,
				657,
				610,
				443
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_5_3.json
// module id = 338
// module chunks = 0